module.exports = __webpack_public_path__ + "static/index/img/login_ico.d228760a.png";